import { ApiProperty } from "@nestjs/swagger";

export class SoIdRequest{
    @ApiProperty()
    saleOrderId:number
}